import { render } from "./Print.vue?vue&type=template&id=2458ef43&scoped=true"
import script from "./Print.vue?vue&type=script&lang=ts"
export * from "./Print.vue?vue&type=script&lang=ts"

import "./Print.vue?vue&type=style&index=0&id=2458ef43&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2458ef43"

export default script